import classNames from 'classnames';
import { Link } from 'react-router-dom';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import HamburgerMenu from 'src/app/components/Elements/HamburgerMenu';
import { TextUs } from 'src/app/components/Elements/Location';
import { medications } from 'src/app/router/paths';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import styles from '../styles.module.scss';

import { NavContainer } from './styles';

interface MobileHeaderProps {
  isInAddInsurance: boolean;
  isFauxLoggedInLayout: boolean;
  hasFixedNav: boolean;
  hideNavBar: boolean;
  showMenu: boolean;
  handleToggleMenu: (e: any) => void;
}

export const MobileHeader = ({
  isInAddInsurance,
  isFauxLoggedInLayout,
  hasFixedNav,
  hideNavBar,
  showMenu,
  handleToggleMenu,
}: MobileHeaderProps) => {
  return (
    <div
      role="navigation"
      aria-label="Main Mobile Navigation Panel"
      className={classNames(styles.header, styles.mobile, styles.whiteBackground, {
        [styles.fauxLoggedIn]: isFauxLoggedInLayout,
        [styles.hasFixedNav]: hasFixedNav,
        [styles.fullOpacity]: hideNavBar,
        [styles.headerInFront]: isInAddInsurance,
      })}
    >
      <NavContainer>
        <div className={classNames(styles.leftIcon)}>
          <HamburgerMenu aligned="left" isActive={showMenu} onClick={handleToggleMenu} />
        </div>
        <div className={styles.logo}>
          {!showMenu && (
            <Link aria-label="Go To Medications Home Page" to={medications.toPath()} data-cy="logo">
              <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.capsule_logo} block />
            </Link>
          )}
        </div>
        <div className={styles.rightIcon}>
          <TextUs>
            <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_chat} block />
          </TextUs>
        </div>
      </NavContainer>
    </div>
  );
};
